// Generated by purs version 0.13.5
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except = require("../Control.Monad.Except/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_DateTime = require("../Data.DateTime/index.js");
var Data_DateTime_Gen = require("../Data.DateTime.Gen/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_JSDate = require("../Data.JSDate/index.js");
var Data_List_NonEmpty = require("../Data.List.NonEmpty/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Test_QuickCheck_Arbitrary = require("../Test.QuickCheck.Arbitrary/index.js");
var Test_QuickCheck_Gen = require("../Test.QuickCheck.Gen/index.js");
var MTime = function (x) {
    return x;
};
var unixTime = (function () {
    var unsafeFromJust = function (x) {
        return Data_Maybe.fromJust()(x);
    };
    var jsdate = Data_Functor.map(Data_Maybe.functorMaybe)(Data_JSDate.fromInstant)(Data_DateTime_Instant.instant(Data_Int.toNumber(0)));
    var dateTime = Control_Bind.bind(Data_Maybe.bindMaybe)(jsdate)(Data_JSDate.toDateTime);
    return MTime(unsafeFromJust(dateTime));
})();
var genericMTime = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showMTime = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericMTime)(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_DateTime.showDateTime))(new Data_Symbol.IsSymbol(function () {
    return "MTime";
}))));
var eqMTime = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_DateTime.eqDateTime)(x)(y);
    };
});
var ordMTime = new Data_Ord.Ord(function () {
    return eqMTime;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_DateTime.ordDateTime)(x)(y);
    };
});
var encodeMTime = new Foreign_Generic_Class.Encode(function (v) {
    var encodeDateTime = (function () {
        var $19 = Foreign_Generic_Class.encode(Foreign_Generic_Class.numberEncode);
        var $20 = Data_Newtype.unwrap(Data_Time_Duration.newtypeMilliseconds);
        return function ($21) {
            return $19($20(Data_DateTime_Instant.unInstant(Data_DateTime_Instant.fromDateTime($21))));
        };
    })();
    return encodeDateTime(v);
});
var decodeMTime = new Foreign_Generic_Class.Decode((function () {
    var decodeDateTime = function (value) {
        var error = Data_Either.Left.create(Data_List_NonEmpty.singleton(new Foreign.TypeMismatch("DateTime", Foreign.tagOf(value))));
        var fromNumber = (function () {
            var $22 = Data_Maybe.maybe(error)(Control_Applicative.pure(Data_Either.applicativeEither));
            var $23 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_DateTime_Instant.toDateTime);
            return function ($24) {
                return $22($23(Data_DateTime_Instant.instant(Data_Time_Duration.Milliseconds($24))));
            };
        })();
        return Control_Monad_Except.mapExcept(Data_Either.either(Data_Function["const"](error))(fromNumber))(Foreign.readNumber(value));
    };
    var $25 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(MTime);
    return function ($26) {
        return $25(decodeDateTime($26));
    };
})());
var arbitraryMTime = new Test_QuickCheck_Arbitrary.Arbitrary(Data_Functor.map(Test_QuickCheck_Gen.functorGen)(MTime)(Data_DateTime_Gen.genDateTime(Test_QuickCheck_Gen.monadGenGen)));
module.exports = {
    MTime: MTime,
    unixTime: unixTime,
    genericMTime: genericMTime,
    showMTime: showMTime,
    eqMTime: eqMTime,
    ordMTime: ordMTime,
    encodeMTime: encodeMTime,
    decodeMTime: decodeMTime,
    arbitraryMTime: arbitraryMTime
};
